import { render, staticRenderFns } from "./quizModulePageNew1.vue?vue&type=template&id=233d6c4b&scoped=true&"
import script from "./quizModulePageNew1.vue?vue&type=script&lang=js&"
export * from "./quizModulePageNew1.vue?vue&type=script&lang=js&"
import style0 from "./quizModulePageNew1.vue?vue&type=style&index=0&id=233d6c4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233d6c4b",
  null
  
)

export default component.exports